{
  "title": "Auditoría",
  "description": "Registro inmutable de las acciones sensibles de tu empresa, con su actor y su marca temporal.",
  "filters": {
    "legend": "Filtros",
    "from": "Desde",
    "to": "Hasta",
    "action": "Acción",
    "actor": "Actor",
    "entityType": "Tipo de entidad",
    "entityId": "Id de la entidad",
    "company": "Empresa",
    "all": "Todas",
    "allActors": "Todos",
    "allEntityTypes": "Todos",
    "allCompanies": "Todas",
    "clear": "Limpiar filtros"
  },
  "columns": {
    "occurredAt": "Fecha y hora",
    "company": "Empresa",
    "companyGlobal": "Plataforma",
    "actor": "Actor",
    "action": "Acción",
    "entity": "Entidad",
    "change": "Cambio"
  },
  "actorSystem": "Sistema",
  "actorUnknown": "Fermin (soporte)",
  "actorTerminal": "Marcador",
  "empty": {
    "title": "Todavía no hay eventos",
    "description": "Cuando se creen sedes, administradores o accesos de soporte, los verás aquí."
  },
  "noResults": {
    "title": "No encontramos eventos",
    "description": "Prueba con otro rango de fechas, otra acción u otro actor."
  },
  "error": {
    "title": "No pudimos cargar la auditoría",
    "description": "Vuelve a intentarlo en unos segundos."
  },
  "drawer": {
    "title": "Detalle del evento",
    "previous": "Valor anterior",
    "new": "Valor nuevo",
    "none": "Sin valor",
    "meta": "Datos del evento",
    "id": "Identificador",
    "ip": "Origen (IP)",
    "entityId": "Id de la entidad",
    "entityLink": "Ver entidad",
    "piiRedacted": "Se ocultan los datos personales: el trabajador fue anonimizado por la política de retención."
  },
  "timezoneHint": "Horas en {timezone}",
  "entities": {
    "unavailable": "No disponible",
    "company": "Empresa",
    "site": "Sede",
    "admin_user": "Administrador",
    "admin_session": "Sesión",
    "worker": "Trabajador",
    "worker_invitation": "Invitación",
    "worker_device": "Dispositivo",
    "device_rebind_request": "Solicitud de re-vinculación",
    "terminal": "Marcador",
    "terminal_session": "Sesión de marcador",
    "terminal_activation_code": "Código de activación",
    "terminal_autonomous_period": "Período autónomo",
    "attendance_mark": "Marca de asistencia",
    "mark_regularization_request": "Solicitud de regularización",
    "shift_template": "Turno",
    "schedule_pattern": "Patrón de horario",
    "worker_schedule_pattern": "Patrón aplicado",
    "shift_assignment": "Horario del día",
    "holiday": "Feriado",
    "worker_absence": "Ausencia",
    "attendance_justification": "Justificación",
    "timesheet_closure": "Cierre de período",
    "integration": "Integración",
    "integration_sync_run": "Sincronización",
    "external_identity": "Vínculo externo",
    "integration_review": "Caso de revisión"
  },
  "actions": {
    "COMPANY_CREATED": "Empresa creada",
    "COMPANY_UPDATED": "Empresa actualizada",
    "COMPANY_SUSPENDED": "Empresa suspendida",
    "COMPANY_REACTIVATED": "Empresa reactivada",
    "ADMIN_INVITED": "Administrador invitado",
    "ADMIN_CREATED": "Administrador creado",
    "ADMIN_UPDATED": "Administrador actualizado",
    "ADMIN_ENABLED": "Administrador habilitado",
    "ADMIN_DISABLED": "Administrador deshabilitado",
    "ADMIN_PASSWORD_RESET": "Contraseña restablecida",
    "SESSION_REVOKED": "Sesión cerrada",
    "SUPPORT_ACCESS_STARTED": "Inicio de acceso de soporte",
    "SUPPORT_ACCESS_ENDED": "Fin de acceso de soporte",
    "SITE_CREATED": "Sede creada",
    "SITE_UPDATED": "Sede actualizada",
    "SITE_DEACTIVATED": "Sede desactivada",
    "RATE_LIMIT_TRIGGERED": "Bloqueo por intentos fallidos",
    "FORBIDDEN_ATTEMPT": "Intento sin permiso",
    "HIBP_UNAVAILABLE": "Verificación de contraseñas no disponible",
    "WORKER_CREATED": "Trabajador creado",
    "WORKER_UPDATED": "Trabajador actualizado",
    "WORKER_DEACTIVATED": "Trabajador dado de baja",
    "WORKER_REACTIVATED": "Trabajador reactivado",
    "WORKER_ACTIVATED": "Trabajador activado",
    "INVITATION_GENERATED": "Invitación generada",
    "INVITATION_REVOKED": "Invitación revocada",
    "DEVICE_ENROLLED": "Dispositivo vinculado",
    "DEVICE_REVOKED": "Dispositivo revocado",
    "DEVICE_REBIND_REQUESTED": "Re-vinculación solicitada",
    "DEVICE_REBIND_APPROVED": "Re-vinculación aprobada",
    "DEVICE_REBIND_REJECTED": "Re-vinculación rechazada",
    "EXPORT_GENERATED": "Exportación generada",
    "TERMINAL_CREATED": "Marcador creado",
    "TERMINAL_UPDATED": "Marcador actualizado",
    "TERMINAL_ACTIVATION_CODE_ISSUED": "Código de activación emitido",
    "TERMINAL_ACTIVATION_CODE_REVOKED": "Código de activación revocado",
    "TERMINAL_ACTIVATED": "Marcador activado",
    "TERMINAL_SESSION_REPLACED": "Sesión de marcador reemplazada",
    "TERMINAL_SESSION_REVOKED": "Sesión de marcador revocada",
    "TERMINAL_DISABLED": "Marcador deshabilitado",
    "TERMINAL_ENABLED": "Marcador habilitado",
    "TERMINAL_AUTONOMOUS_STARTED": "Modo autónomo iniciado",
    "TERMINAL_AUTONOMOUS_ENDED": "Modo autónomo finalizado",
    "MARK_CREATED": "Marcación registrada",
    "MISSING_CHECKOUT": "Salida no registrada",
    "MANUAL_MARK_CREATED": "Marcación manual registrada",
    "MARK_SUPERSEDED": "Marcación corregida",
    "MARK_VOIDED": "Marcación anulada",
    "MISSING_CHECKOUT_CLEARED": "Salida no registrada resuelta",
    "LOCATION_DATA_PURGED": "Ubicaciones eliminadas por retención",
    "WORKER_ANONYMIZED": "Trabajador anonimizado",
    "MARK_REGULARIZATION_REQUESTED": "Regularización solicitada",
    "MARK_REGULARIZATION_ASKED": "Regularización pedida al trabajador",
    "MARK_REGULARIZATION_APPROVED": "Regularización aprobada",
    "MARK_REGULARIZATION_REJECTED": "Regularización rechazada",
    "MARK_REGULARIZATION_CANCELLED": "Regularización cancelada",
    "SHIFT_TEMPLATE_CREATED": "Turno creado",
    "SHIFT_TEMPLATE_UPDATED": "Turno actualizado",
    "SHIFT_TEMPLATE_VERSIONED": "Nuevo horario de turno",
    "SHIFT_TEMPLATE_ARCHIVED": "Turno archivado",
    "SCHEDULE_PATTERN_CREATED": "Patrón creado",
    "SCHEDULE_PATTERN_UPDATED": "Patrón actualizado",
    "SCHEDULE_PATTERN_ARCHIVED": "Patrón archivado",
    "SCHEDULE_PATTERN_APPLIED": "Patrón aplicado",
    "SCHEDULE_PATTERN_ENDED": "Patrón terminado",
    "SHIFT_ASSIGNMENT_CHANGED": "Horario del día cambiado",
    "HOLIDAY_CREATED": "Feriado registrado",
    "HOLIDAY_REMOVED": "Feriado quitado",
    "ABSENCE_CREATED": "Ausencia registrada",
    "ABSENCE_CANCELLED": "Ausencia cancelada",
    "JUSTIFICATION_REQUESTED": "Justificación solicitada",
    "JUSTIFICATION_REGISTERED": "Justificación registrada por el administrador",
    "JUSTIFICATION_APPROVED": "Justificación aprobada",
    "JUSTIFICATION_REJECTED": "Justificación rechazada",
    "JUSTIFICATION_CANCELLED": "Justificación cancelada",
    "TIMESHEET_PERIOD_CLOSED": "Período del tareo cerrado",
    "TIMESHEET_PERIOD_REOPENED": "Período del tareo reabierto",
    "INTEGRATION_CONNECTION_CREATED": "Conexión con sistema externo creada",
    "INTEGRATION_CONNECTION_UPDATED": "Conexión con sistema externo actualizada",
    "INTEGRATION_CONNECTION_VERIFIED": "Conexión con sistema externo verificada",
    "INTEGRATION_CONNECTION_DISABLED": "Integración desactivada",
    "INTEGRATION_CONNECTION_ENABLED": "Integración activada",
    "INTEGRATION_SYNC_STARTED": "Sincronización iniciada",
    "INTEGRATION_SYNC_CONFIRMED": "Sincronización confirmada",
    "INTEGRATION_SYNC_FINISHED": "Sincronización terminada",
    "INTEGRATION_LINK_CREATED": "Vínculo con sistema externo creado",
    "INTEGRATION_LINK_REMOVED": "Vínculo con sistema externo quitado",
    "INTEGRATION_REVIEW_RESOLVED": "Caso de revisión resuelto",
    "INTEGRATION_REVIEW_REOPENED": "Caso de revisión reabierto"
  },
  "origin": {
    "INTEGRATION": "Integración"
  }
}
